import { useQuery } from '@tanstack/react-query'

import { accountQueries } from '@/entities/account'

export const useBankCodes = () => {
  const { data: banks } = useQuery({
    ...accountQueries.bankCodes(),
    staleTime: Infinity,
  })

  return {
    banks,
  }
}
